import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function TransformationSection() {
  const beforeItems = ['Sesiones de estudio de 5 minutos interrumpidas', 'Procrastinación constante', 'Frustración y abandono de proyectos', "Dependencia del teléfono para 'descansar'", 'Notas por debajo de su potencial real'];
  const afterItems = ['Bloques de enfoque de 45-90 minutos', 'Acción inmediata sobre las tareas importantes', 'Proyectos completados con orgullo', 'Descansos estratégicos que recargan energía', 'Rendimiento académico que refleja su verdadero potencial'];
  return <section className="py-20 bg-[#1B3A6B] text-white relative overflow-hidden" data-id="element-156">
      {/* Background patterns */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-157">
        <div className="absolute right-0 top-0 w-96 h-96 bg-blue-400 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-158" />
        <div className="absolute left-0 bottom-0 w-96 h-96 bg-[#F97316] rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-159" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-160">
        <div className="text-center mb-16" data-id="element-161">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-bold mb-4 uppercase text-white" data-id="element-162">
            La Transformación que Verás
          </motion.h2>
          <div className="h-1 w-24 bg-[#F97316] mx-auto rounded-full" data-id="element-163" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-164">
          {/* BEFORE Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10" data-id="element-165">
            <h3 className="text-2xl font-bold mb-8 text-red-300 flex items-center gap-3 uppercase" data-id="element-166">
              <span className="bg-red-500/20 p-2 rounded-lg" data-id="element-167">
                <X className="h-6 w-6" data-id="element-168" />
              </span>
              Antes
            </h3>
            <ul className="space-y-6" data-id="element-169">
              {beforeItems.map((item, idx) => <li key={idx} className="flex items-start gap-4 text-slate-300" data-id="element-170">
                  <X className="h-5 w-5 text-red-400 mt-1 flex-shrink-0" data-id="element-171" />
                  <span className="text-lg" data-id="element-172">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* AFTER Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border-2 border-[#2B7FD4] shadow-2xl relative overflow-hidden" data-id="element-173">
            <div className="absolute top-0 right-0 bg-[#2B7FD4] text-white text-xs font-bold px-3 py-1 rounded-bl-lg uppercase" data-id="element-174">
              Objetivo
            </div>

            <h3 className="text-2xl font-bold mb-8 text-[#4ADE80] flex items-center gap-3 uppercase" data-id="element-175">
              <span className="bg-[#4ADE80]/20 p-2 rounded-lg" data-id="element-176">
                <Check className="h-6 w-6" data-id="element-177" />
              </span>
              Después
            </h3>
            <ul className="space-y-6" data-id="element-178">
              {afterItems.map((item, idx) => <li key={idx} className="flex items-start gap-4 text-white font-medium" data-id="element-179">
                  <div className="bg-[#4ADE80] rounded-full p-1 mt-1 flex-shrink-0" data-id="element-180">
                    <Check className="h-3 w-3 text-[#1B3A6B]" data-id="element-181" />
                  </div>
                  <span className="text-lg" data-id="element-182">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}